<template>
  <div>
    <Head title="會員中心 - 常用收件地址" />
    <user-template title="會員中心">
      <template #header>常用收件地址</template>

      <main>
        <div v-if="contacts.length > 0">
          <contact
            :key="getItemKey(contact)"
            v-for="(contact, index) in contacts"
            :contact="contact"
            :index="index"
            @deleteContact="deleteContact"
          />
        </div>
        <div class="my-5" v-else>沒有任何常用收件地址。</div>
        <div v-show="contacts.length < 5" class="w-full text-left">
          <Button label="新增收件地址" @click="addContact" />
        </div>
        <div class="w-full text-right">
          <Button label="儲存變更" @click="saveContacts" />
        </div>
      </main>
    </user-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import UserTemplate from "./Shared/UserTemplate";
import Contact from "./Components/AddressBook/Contact";
import Button from "primevue/button";

export default {
  components: {
    UserTemplate,
    Contact,
    Button,
  },
  layout: Layout,
  data() {
    return {
      contacts: this.$page.props.auth.user.preferences?.address_book ?? [],
    };
  },
  methods: {
    getItemKey(item) {
      if (!item.random) {
        item.random = Math.random().toString(36).substring(2);
      }
      return item.random;
    },
    addContact() {
      this.contacts.push({
        name: null,
        sex: 1,
        phone: null,
        shipping_info: {
          city: null,
          district: null,
          address: null,
        },
      });
    },
    saveContacts() {
      this.$inertia.post(route("user.profile.address_book"), this.contacts, {
        only: ["errors", "flash"],
        preserveState: true,
        preserveScroll: true,
      });
    },
    deleteContact(index) {
      this.contacts.splice(index, 1);
    },
  },
};
</script>

<style lang="postcss">
/*  */
</style>